import React, { useRef} from 'react';
import {useFrame, useThree} from '@react-three/fiber'
import * as THREE from 'three'
import {OrbitControls} from "@react-three/drei";
import useStore from "../store";
import { degToRad } from "three/src/math/MathUtils";


function Camera() {
    const flymode = useStore(state => state.flymode)
    const frameTime = useStore(state => state.frameTime)
    const controls = useRef();
    const {camera, gl} = useThree();

    const cell =  useStore(state => state.station)-1;
    const i = cell === -1 ? -1 : cell - (Math.floor(cell / 17) * 17);

    const x = (150 * Math.sin(degToRad(360 / 17 * i)));
    const z = (150 * Math.cos(degToRad(360 / 17 * i)))
    const newPoint = i === -1 ? new THREE.Vector3(0, 0, 167) : new THREE.Vector3(x, 3, z);


    useFrame((state, delta) => {
        if (flymode) return
        controls.current.target.lerp(newPoint, frameTime * 0.008 * 115);
        controls.current.update();
    })
    

    return (
        <>
            <OrbitControls args={[camera, gl.domElement]} ref={controls}/>
        </>
    )

}

export default Camera;
